<template>
    <MenuDesktopInline class="desktop-only"/>
</template>

<style lang="scss" scoped>
</style>

<script>
import MenuDesktopInline from '@/components/Menu/MenuDesktopInline';

export default {
    name: 'AppHeaderDesktopNavigation',
    components: {
        MenuDesktopInline,
    }
};
</script>